import { GET_INFO_CARDS_ERROR, GET_INFO_CARDS_START, GET_INFO_CARDS_SUCCESS } from '../../types';

export default function get_info_cards(state, action) {
  switch (action.type) {
    case GET_INFO_CARDS_START:
      return { ...state };
    case GET_INFO_CARDS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_INFO_CARDS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
